<template>
  <div
    class="properties d-flex flex-column flex-nowrap ps-container ps-theme-default"
    data-ps-id="59a37192-e91f-4922-22fd-5d7957e8a44e"
    style="height: 852px;"
  >
    <slot />
    <div class="ps-scrollbar-x-rail" style="left: 0px; bottom: 0px;">
      <div
        class="ps-scrollbar-x"
        tabindex="0"
        style="left: 0px; width: 0px;"
      ></div>
    </div>
    <div class="ps-scrollbar-y-rail" style="top: 0px; right: 0px;">
      <div
        class="ps-scrollbar-y"
        tabindex="0"
        style="top: 0px; height: 0px;"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "volcan-card-property",
  props: ["data"],
  data: function() {
    return {};
  },
  computed: {},
  mounted() {},
  watch: {},
  methods: {}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/AdminTools/card/card-property.vue